var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "under-cart__atomizer" };
const _hoisted_2 = { class: "btn__icon" };
import { ref } from 'vue';
import AtomizerModal from './AtomizerModal.vue';
import useCartApi from "../../api";
import Sprite from "../../../../components/Sprite.vue";
import { showPreloader } from "../../../../components/preloader";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Atomizers',
    setup(__props) {
        let atomizers = ref([]);
        const modal = ref();
        const api = useCartApi();
        function showModal() {
            return __awaiter(this, void 0, void 0, function* () {
                var _a;
                showPreloader();
                if (!atomizers.value.length) {
                    const data = yield api.getAtomizers();
                    if (data) {
                        atomizers.value = data;
                    }
                }
                (_a = modal.value) === null || _a === void 0 ? void 0 : _a.show();
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("button", {
                    onClick: showModal,
                    type: "button",
                    class: "btn btn--2 btn--m btn--black"
                }, [
                    _createElementVNode("span", _hoisted_2, [
                        _createVNode(Sprite, { name: "atomizer" })
                    ]),
                    _cache[0] || (_cache[0] = _createTextVNode()),
                    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "btn__label" }, "Добавить атомайзер", -1 /* CACHED */))
                ]),
                _cache[2] || (_cache[2] = _createTextVNode()),
                (_unref(atomizers).length)
                    ? (_openBlock(), _createBlock(AtomizerModal, {
                        key: 0,
                        ref_key: "modal",
                        ref: modal,
                        atomizers: _unref(atomizers)
                    }, null, 8 /* PROPS */, ["atomizers"]))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
